import component from "./index.component";
import wrapper from "./index.wrapper";

export default wrapper(component);
